import Element from 'ui/Element';
import ClickableMixin from './mixins/ClickableMixin';
import ContainableMixin from './mixins/ContainableMixin';
import mixin from 'privates/utils/mixin';
import StyleMixin from './mixins/styleMixins/StyleMixin';

/**
 * @class Header
 * @summary The header is the area of your site that appears at the top and
 *  throughout all of your pages.
 * @classdesc The header is located at the top of the page:
 *  ![Wix Page Header](images/header.png "Wix Page Header")
 *  The header is a container that can contain other elements.
 *
 *  The contained elements are the header's [children](#children) and the
 *  header is the contained elements' [parent](#parent).
 *
 *  The same header appears on all pages of your site. Therefore, The children
 *  elements of a header appear on all pages of your site.
 * 
 *  The `Header` is part of the [`Document`](#$w.Document.html). 
 * @see [Footer]($w.Footer.html)
 * @see [Document]($w.Document.html)
 * @mixes $w.Element
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @mixes $w.StyleMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.HeaderContainer
 * @definitionId wysiwyg.viewer.components.HeaderContainer
 * @tagname header
 */
class Header extends Element {

}

/**
 * @member style
 * @label property
 * @syntax
 * get style(): Style
 * @summary Gets an object containing information about the header's styles.
 * @description
 *  The following styles can be used with headers:
 *
 *  + [`backgroundColor`]($w.Style.html#backgroundColor)
 *  + [`borderColor`]($w.Style.html#borderColor)
 * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
 * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
 * @type {$w.Style}
 * @memberof $w.Header
 * @readonly
 * @override
 */

mixin(Header.prototype, ClickableMixin.prototype);
mixin(Header.prototype, ContainableMixin.prototype);
mixin(Header.prototype, StyleMixin.prototype);

export default Header;



// WEBPACK FOOTER //
// ./js/modules/ui/Header.es6